import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';

// Modale d'aperçu d'une section : une iframe sur l'application d'aperçu
// (cf. sectionPreviewApp.jsx), qui rend la section comme à l'écran, sans
// éditeur ni collaboration.
//
// L'iframe est la protection : elle a son propre store, son propre cycle de
// vie, et ne peut rien changer au document ouvert dans l'onglet. `sandbox`
// borne ce que la page peut faire — scripts et même origine (nécessaires pour
// React et pour le JWT du localStorage), rien d'autre : ni navigation du parent,
// ni popup, ni téléchargement.
const SectionPreviewModal = ({ sectionId, open, onClose }) => {
  const { t } = useTranslation();

  const src = useMemo(() => {
    if (sectionId == null) return null;
    const url = new URL(window.location.href);
    // Repartir d'une URL propre : un pid/oid résiduel ferait charger tout autre
    // chose que la section demandée.
    url.search = '';
    url.searchParams.set('tid', String(sectionId));
    url.searchParams.set('section_preview', '1');
    return url.toString();
  }, [sectionId]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width='min(1100px, 92vw)'
      title={t('section_preview_title')}
      destroyOnHidden
      // L'aperçu s'ouvre depuis une option d'un menu déroulant, qui reste
      // ouvert derrière pour qu'on puisse reprendre son choix en fermant. La
      // prop `zIndex` seule ne suffisait pas : antd la pose sur le wrap, mais la
      // liste du Select est empilée par le gestionnaire de z-index d'antd
      // au-dessus. Même remède que la modale d'organigramme et celle de
      // disposition : on force mask et wrap par le `rootClassName`
      // (cf. index.less), sous les toasts (10200) qui doivent rester lisibles.
      rootClassName='section-preview-modal-root'
      // Le contenu de la modale vit dans un portail, mais reste un enfant React
      // de la box : sans ce marqueur, cliquer dedans (ou sur la croix) est vu
      // comme un clic hors de la box et la désélectionne.
      modalRender={(node) => <div data-outside-ignore="true">{node}</div>}
      styles={{ body: { padding: 0, height: '78vh' } }}
    >
      {src && (
        <iframe
          key={src}
          src={src}
          title={t('section_preview_title')}
          sandbox='allow-scripts allow-same-origin'
          style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
        />
      )}
    </Modal>
  );
};

export default SectionPreviewModal;
